import Const from 'beek-design-system/config/Const';

const fallbacks = {
  audioCoverFallback: `${Const.cdnUrl}/design-system/images/fallbacks/audio_cover.jpg`,
  articlePageCoverFallback: `${Const.cdnUrl}/design-system/images/fallbacks/article_page_cover.jpg`,
  articleCoverFallback: `${Const.cdnUrl}/design-system/images/fallbacks/article_cover.jpg`,
  error404Fallback: `${Const.cdnUrl}/design-system/images/fallbacks/error404.webp`,
};

export default fallbacks;
